import React from 'react';
import { motion } from 'framer-motion';
import { FaFacebook, FaInstagram } from 'react-icons/fa';

class Footer extends React.Component {
  render() {
    return (
      <motion.footer
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        className="bg-gray-900 text-white py-12"
      >
        <div className="max-w-6xl mx-auto px-4">
          {/* Layout em Grid */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Seção Sobre */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold mb-4">Sobre Diego Trainer</h3>
              <p className="text-gray-400">
              Personal Trainer Certificado e Especialista em Perda de Gordura, com mais de 12 anos de experiência ajudando clientes a eliminar gordura persistente e transformar seus corpos. Ofereço treinos personalizados, baseados na ciência, entregues de forma prática no seu celular pelo meu aplicativo.
              </p>
            </motion.div>

            {/* Links Rápidos */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold mb-4">Links Rápidos</h3>
              <ul className="text-gray-400">
                <li className="mb-2"><a href="#home" className="hover:text-blue-500">Home</a></li>
                <li className="mb-2"><a href="#features" className="hover:text-blue-500">Funcionalidades</a></li>
                <li className="mb-2"><a href="#coach" className="hover:text-blue-500">Sobre o Coach</a></li>
                <li className="mb-2"><a href="#results" className="hover:text-blue-500">Resultados de Clientes</a></li>
                <li className="mb-2"><a href="#faq" className="hover:text-blue-500">Perguntas Frequentes</a></li>
                <li className="mb-2"><a href="#pricing" className="hover:text-blue-500">Preços</a></li>
              </ul>
            </motion.div>

            {/* Informações de Contato */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold mb-4">Contato</h3>
              <ul className="text-gray-400">
                <li className="mb-2">
                  E-mail: <a href="mailto:support@diegotrainer.com" className="text-blue-500 hover:underline">support@diegotrainer.com</a>
                </li>
              </ul>
            </motion.div>

            {/* Redes Sociais */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.8 }}
              viewport={{ once: true }}
            >
              <h3 className="text-xl font-bold mb-4">Siga-me</h3>
              <div className="flex space-x-4">
                <motion.a
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  target="_blank" 
                  rel="noopener noreferrer"
                  href="https://www.facebook.com/DiegoTrainer/"
                  className="text-gray-400 hover:text-blue-500"
                >
                  <FaFacebook className="w-6 h-6" />
                </motion.a>
                <motion.a
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  target="_blank" 
                  rel="noopener noreferrer"
                  href="https://www.instagram.com/diego.trainer"
                  className="text-gray-400 hover:text-blue-500"
                >
                  <FaInstagram className="w-6 h-6" />
                </motion.a>
              </div>
            </motion.div>
          </div>

          {/* Isenção de Responsabilidade do eBook com Animação */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            viewport={{ once: true }}
            className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-xs space-y-2"
          >
            <motion.p 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.7 }}
            >
              ✉️ O eBook gratuito será enviado para seu e-mail assim que você concluir o processo de inscrição.
            </motion.p>
            
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.9 }}
            >
              🔄 Você pode cancelar a assinatura a qualquer momento antes de 14 dias e ainda assim manter o eBook.
            </motion.p>
            
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.1 }}
            >
              💳 A cobrança recorrente começa automaticamente no 15º dia - gerencie em sua conta.
            </motion.p>
          </motion.div>

          {/* Seção de Direitos Autorais */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 1, duration: 0.8 }}
            viewport={{ once: true }}
            className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400"
          >
            <p>&copy; {new Date().getFullYear()} Diego Trainer. Todos os direitos reservados.</p>
          </motion.div>
        </div>
      </motion.footer>
    );
  }
}

export default Footer;